(function () {
var $d1ca1ac2006539cd$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    var toggleButton = document.querySelector(".navbar__toggle");
    var closeButton = document.querySelector(".navbar__close-toggle");
    var menu = document.querySelector(".navbar__menu");
    var menuItems = menu.querySelectorAll(".menu-item a");
    var getLastPathSegment = function(url) {
        var path = new URL(url).pathname;
        return path === "/" ? "/index.html" : path;
    };
    var currentPath = getLastPathSegment(window.location.href);
    toggleButton.addEventListener("click", function() {
        menu.classList.add("active");
        toggleButton.classList.add("navbar__toggle--hidden");
    });
    closeButton.addEventListener("click", function() {
        menu.classList.remove("active");
        toggleButton.classList.remove("navbar__toggle--hidden");
    });
    menuItems.forEach(function(link) {
        link.addEventListener("click", function() {
            menu.classList.remove("active");
            toggleButton.classList.remove("navbar__toggle--hidden");
        });
        if (getLastPathSegment(link.href) === currentPath) link.parentElement.classList.add("menu-item--active");
    });
});

})();
//# sourceMappingURL=index.93d4df7f.js.map
